import React from 'react';
import LinkDownloadAppPresenter from './LinkDownloadAppPresenter';

const LinkDownloadApp = () => {
  return <LinkDownloadAppPresenter />;
};

export default LinkDownloadApp;
